import { useFormContext, useFieldArray } from "react-hook-form";

import { FormValues } from "../edit-holiday-list-form";
import { DataTable } from "./data-table";
import { columns } from "./columns";

export const HalfDaysTable = () => {
  const formContext = useFormContext<FormValues>();

  const {
    append: appendHalfDayRow,
    remove: removeHalfDayRow,
    fields: halfDayRows,
    update: updateHalfDayRow,
  } = useFieldArray({
    name: "halfDays",
    control: formContext.control,
  });

  return (
    <div className="px-4 mt-5">
      <h3 className="my-3">Half Days</h3>
      <DataTable
        columns={columns}
        data={halfDayRows}
        removeHalfDayRow={removeHalfDayRow}
        appendHalfDayRow={appendHalfDayRow}
        updateHalfDayRow={updateHalfDayRow}
      />
    </div>
  );
};
